import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  obtenerCategories() {
    var url = ConfigAPI.baseURL + "instances-categories" + Session.getToken();
    return instance.get(url);
  },
  obtenerCategoriesByType(type) {
    var params = { type: type }
    var url = ConfigAPI.baseURL + "instances-categories/filter/by-type" + Session.getToken();
    return instance.post(url, params);
  },
  mostrarCategories(id) {
    var url = ConfigAPI.baseURL + "instances-categories/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarCategories(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "instances-categories" + Session.getToken();
    return instance.post(url,params);
  },
  editarCategories(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "instances-categories/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarCategories(id) {
    var url = ConfigAPI.baseURL + "instances-categories/"+ id + Session.getToken();
    return instance.delete(url);
  }, 
  filtrarCategories(data, page) {
    var params = data    
    var url = ConfigAPI.baseURL + "instances-categories/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url, params);
  },    

  // SERVIDORES E INSTANCIAS (datos administrativos; lo técnico lo administra Monitor)
  filtrarMonitorServidor(data) {
    var params = data
    var url = ConfigAPI.baseURL + "instances-monitor-server/filter/query" + Session.getToken();
    return instance.post(url,params);
  },
  mostrarMonitorServidor(id) {
    var url = ConfigAPI.baseURL + "instances-monitor-server/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarMonitorServidor(data) {
    var params = data
    var url = ConfigAPI.baseURL + "instances-monitor-server" + Session.getToken();
    return instance.post(url,params);
  },
  editarMonitorServidor(data) {
    var params = data
    var url = ConfigAPI.baseURL + "instances-monitor-server/" + data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarMonitorServidor(id) {
    var url = ConfigAPI.baseURL + "instances-monitor-server/" + id + Session.getToken();
    return instance.delete(url);
  },
  filtrarMonitorSistema(data) {
    var params = data
    var url = ConfigAPI.baseURL + "instances-monitor-system/filter/query" + Session.getToken();
    return instance.post(url,params);
  },
  mostrarMonitorSistema(id) {
    var url = ConfigAPI.baseURL + "instances-monitor-system/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarMonitorSistema(data) {
    var params = data
    var url = ConfigAPI.baseURL + "instances-monitor-system" + Session.getToken();
    return instance.post(url,params);
  },
  editarMonitorSistema(data) {
    var params = data
    var url = ConfigAPI.baseURL + "instances-monitor-system/" + data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarMonitorSistema(id) {
    var url = ConfigAPI.baseURL + "instances-monitor-system/" + id + Session.getToken();
    return instance.delete(url);
  },

  // CONFIGURACION - token de integración con Monitor
  obtenerMonitorToken() {
    var url = ConfigAPI.baseURL + "instances/config/monitor-token" + Session.getToken();
    return instance.get(url);
  },
  generarMonitorToken() {
    var url = ConfigAPI.baseURL + "instances/config/monitor-token" + Session.getToken();
    return instance.post(url);
  },
  revocarMonitorToken() {
    var url = ConfigAPI.baseURL + "instances/config/monitor-token" + Session.getToken();
    return instance.delete(url);
  },
  obtenerMonitorDocs(format) {
    var url = ConfigAPI.baseURL + "instances/config/monitor-docs" + Session.getToken() + (format ? "&format=" + format : "");
    return instance.get(url);
  },

  obtenerClientes() {
    var url = ConfigAPI.baseURL + "customers" + Session.getToken();
    return instance.get(url);
  },
  obtenerMonedas() {
    var url = ConfigAPI.baseURL + "price-currency" + Session.getToken();
    return instance.get(url);
  },
  obtenerProveedores() {
    var url = ConfigAPI.baseURL + "suppliers" + Session.getToken();
    return instance.get(url);
  },  
}

export default servicesAPI;
